export var LogLevel;
(function (LogLevel) {
    LogLevel[LogLevel["TRACE"] = 10] = "TRACE";
    LogLevel[LogLevel["DEBUG"] = 20] = "DEBUG";
    LogLevel[LogLevel["INFO"] = 30] = "INFO";
    LogLevel[LogLevel["WARN"] = 40] = "WARN";
    LogLevel[LogLevel["ERROR"] = 50] = "ERROR";
    LogLevel[LogLevel["FATAL"] = 60] = "FATAL";
    LogLevel[LogLevel["SILENT"] = 100] = "SILENT";
})(LogLevel || (LogLevel = {}));
var AbstractLogger = (function () {
    function AbstractLogger(name) {
        var _a;
        if (name === void 0) { name = ''; }
        this.defaultLevel = LogLevel.WARN;
        this.noop = function () { return null; };
        this.name = name;
        this.setDefaultLevelFromLocalStorage();
        Object.assign(AbstractLogger.loggers, (_a = {}, _a[name] = this, _a));
    }
    AbstractLogger.prototype.getName = function () {
        return this.name;
    };
    AbstractLogger.prototype.setLevel = function (level) {
        this.level = level;
    };
    AbstractLogger.prototype.getLevel = function () {
        return typeof this.level === 'number' && isFinite(this.level) && Math.floor(this.level) === this.level ? this.level : this.defaultLevel;
    };
    AbstractLogger.prototype.shouldLog = function (method) {
        switch (this.getLevel()) {
            case LogLevel.SILENT:
                return false;
            case LogLevel.FATAL:
                return method === 'fatal';
            case LogLevel.ERROR:
                return method === 'fatal' || method === 'error';
            case LogLevel.WARN:
                return method === 'fatal' || method === 'error' || method === 'warn';
            case LogLevel.INFO:
                return method === 'fatal' || method === 'error' || method === 'warn' || method === 'info';
            case LogLevel.DEBUG:
                return method === 'fatal' || method === 'error' || method === 'warn' || method === 'info' || method === 'debug';
            case LogLevel.TRACE:
            default:
                return true;
        }
    };
    AbstractLogger.prototype.setDefaultLevelFromLocalStorage = function () {
        if (!global.window || !global.window.hasOwnProperty('localStorage')) {
            return;
        }
        var loglevel = global.window.localStorage.getItem('loglevel');
        if (!loglevel) {
            return;
        }
        this.setLevel(AbstractLogger.getLogLevel(loglevel));
    };
    AbstractLogger.getLogLevel = function (loglevel) {
        var level = loglevel.toLowerCase();
        switch (level) {
            case 'silent':
                return LogLevel.SILENT;
            case 'fatal':
                return LogLevel.FATAL;
            case 'error':
                return LogLevel.ERROR;
            case 'warn':
                return LogLevel.WARN;
            case 'info':
                return LogLevel.INFO;
            case 'debug':
                return LogLevel.DEBUG;
            case 'trace':
                return LogLevel.TRACE;
            default:
                throw new Error("Invalid log level: " + level);
        }
    };
    AbstractLogger.getLogger = function (name, LoggerClass) {
        if (AbstractLogger.loggers.hasOwnProperty(name)) {
            return AbstractLogger.loggers[name];
        }
        var logger = new LoggerClass(name);
        AbstractLogger.loggers[name] = logger;
        return logger;
    };
    AbstractLogger.loggers = {};
    return AbstractLogger;
}());
export { AbstractLogger };
//# sourceMappingURL=AbstractLogger.js.map